export default {
  // 导航
  'muse.nav.workspace': '工作台',
  'muse.nav.voice': '声音',
  'muse.nav.voiceTemplate': '音色模板',
  'muse.nav.voiceSynth': '声音合成',
  'muse.nav.video': '视频',
  'muse.nav.avatar': '数字人形象',
  'muse.nav.avatarGenerate': '数字人生成',
  'muse.nav.adminDashboard': '仪表盘',
  'muse.nav.adminAvatar': '平台数字人形象',
  'muse.nav.adminTask': '合成任务',
  'muse.nav.adminModel': '接口配置',
  'muse.nav.adminPricing': '计费设置',

  // 首页（介绍页）
  'muse.intro.pageTitle': 'AI 声音与数字人视频创作平台',
  'muse.intro.login': '登录',
  'muse.intro.start': '开始使用',
  'muse.intro.nav.features': '功能',
  'muse.intro.nav.voice': '声音',
  'muse.intro.nav.video': '视频',
  'muse.intro.nav.ways': '接入方式',
  'muse.intro.nav.menu': '菜单',
  'muse.intro.badge': 'AI 声音 · 数字人视频',
  'muse.intro.hero.titleLead': '让每一个创意，',
  'muse.intro.hero.titleAccent': '都有声音与形象',
  'muse.intro.hero.subtitle': '从一段文字到数字人视频：声音合成、声音复刻、形象生成，都在同一个工作台。',
  'muse.intro.hero.ctaPublic': '免费开始创作',
  'muse.intro.hero.ctaApp': '进入工作台',
  'muse.intro.hero.secondaryPublic': '了解功能',
  'muse.intro.hero.imageAlt': '数字人形象与音频预览',
  'muse.intro.hero.note': '无需剪辑经验 · 多语言音色 · 支持 API 接入',
  'muse.intro.hero.noteNoEdit': '无需剪辑经验',
  'muse.intro.hero.noteMultilingual': '多语言音色',
  'muse.intro.hero.noteApi': '支持 API 接入',
  'muse.intro.hero.chipVoice': '声音复刻 · 30 秒',
  'muse.intro.hero.chipVideo': '数字人视频 · 4K',
  'muse.intro.hero.chipLang': '20+ 语言与音色',
  'muse.intro.hero.nowPlaying': '品牌宣传片 · 数字人旁白',
  'muse.intro.feature.title': '一站式 AI 创作能力',
  'muse.intro.feature.subtitle': '声音、形象、视频与接口，围绕内容生产打通。',
  'muse.intro.feature.tts': '声音合成',
  'muse.intro.feature.ttsDesc': '输入文字，直接生成自然流畅的配音。',
  'muse.intro.feature.clone': '声音复刻',
  'muse.intro.feature.cloneDesc': '上传一小段录音，复刻专属音色。',
  'muse.intro.feature.template': '音色模板',
  'muse.intro.feature.templateDesc': '从精选音色库中快速挑选合适声线。',
  'muse.intro.feature.avatar': '数字人形象',
  'muse.intro.feature.avatarDesc': '平台形象与自定义形象统一管理。',
  'muse.intro.feature.video': '数字人视频',
  'muse.intro.feature.videoDesc': '文本或音频驱动，分钟级生成视频。',
  'muse.intro.feature.lang': '多语言支持',
  'muse.intro.feature.langDesc': '多语言音色与口型适配。',
  'muse.intro.feature.api': 'API 接入',
  'muse.intro.feature.apiDesc': '按任务调用声音与视频合成能力。',
  'muse.intro.feature.task': '任务管理',
  'muse.intro.feature.taskDesc': '合成记录、状态与消耗一目了然。',
  'muse.intro.voice.title': '一段文字，千种声线',
  'muse.intro.voice.desc': '把文案交给 {name}，几秒内得到可直接使用的配音；也可以复刻你的声音，让品牌保持统一听感。',
  'muse.intro.voice.bullet1': '声音合成与声音复刻共用一套工作流',
  'muse.intro.voice.bullet2': '音色模板按场景筛选，试听即用',
  'muse.intro.voice.bullet3': '支持长文本与多语言内容',
  'muse.intro.voice.cta': '开始合成',
  'muse.intro.voice.tag': '声音工作台',
  'muse.intro.voice.track': '品牌宣传片 · 旁白',
  'muse.intro.video.title': '让数字人替你出镜',
  'muse.intro.video.desc': '选择形象、上传文案或音频，系统自动完成口型、表情与画面合成，输出可发布的数字人视频。',
  'muse.intro.video.bullet1': '平台形象与自定义形象统一管理',
  'muse.intro.video.bullet2': '文本 / 音频两种驱动方式',
  'muse.intro.video.bullet3': '任务进度与结果集中查看',
  'muse.intro.video.cta': '创建视频',
  'muse.intro.video.tag': '数字人视频',
  'muse.intro.stats.cloneValue': '30s',
  'muse.intro.stats.cloneLabel': '完成声音复刻',
  'muse.intro.stats.qualityValue': '4K',
  'muse.intro.stats.qualityLabel': '数字人视频输出',
  'muse.intro.stats.langValue': '20+',
  'muse.intro.stats.langLabel': '语言与音色',
  'muse.intro.ways.title': '灵活的接入方式',
  'muse.intro.ways.subtitle': '从团队创作到产品集成，按你的方式使用 {name}。',
  'muse.intro.ways.webTitle': '控制台创作',
  'muse.intro.ways.webDesc': '在 Web 工作台完成声音、形象与视频制作，适合内容团队。',
  'muse.intro.ways.apiTitle': 'API 接入',
  'muse.intro.ways.apiDesc': '把声音合成与数字人视频能力接入你的产品与业务系统。',
  'muse.intro.ways.customTitle': '企业定制',
  'muse.intro.ways.customDesc': '按品牌定制音色、形象与工作流，适配更复杂的生产场景。',
  'muse.intro.ways.action': '了解详情',
  'muse.intro.final.title': '把创意交给 {name}',
  'muse.intro.final.desc': '从第一句文案开始，生成属于你的声音与数字人视频。',
  'muse.intro.final.button': '立即开始',
  'muse.intro.footer.product': '产品',
  'muse.intro.footer.voice': '声音合成',
  'muse.intro.footer.video': '数字人视频',
  'muse.intro.footer.api': 'API 接入',
  'muse.intro.footer.copyright': '© {year} {name}',

  // 通用
  'muse.type.soundTts': '声音合成',
  'muse.type.soundClone': '声音复刻',
  'muse.type.videoGen': '数字人生成',
  'muse.status.queue': '排队中',
  'muse.status.process': '处理中',
  'muse.status.success': '成功',
  'muse.status.fail': '失败',
  'muse.uploadAudio': '上传音频',
  'muse.uploadVideo': '上传视频',
  'muse.audio.uploadHint': '点击上传或拖拽音频文件到此处',
  'muse.audio.untitled': '未命名音频',
  'muse.audio.reupload': '点击更换音频',
  'muse.uploading': '上传中...',
  'muse.play': '播放',
  'muse.delete': '删除',
  'muse.edit': '修改',
  'muse.confirmDelete': '确定要删除吗？',

  // 仪表盘
  'muse.dashboard.title': '仪表盘',
  'muse.dashboard.statTotal': '任务总数',
  'muse.dashboard.statSuccess': '成功任务',
  'muse.dashboard.statFail': '失败任务',
  'muse.dashboard.statConsumed': '消耗点数',
  'muse.dashboard.statUsers': '用户数',

  // 合成任务（管理）
  'muse.task.title': '合成任务',
  'muse.task.colId': 'ID',
  'muse.task.colUser': '用户',
  'muse.task.colType': '类型',
  'muse.task.colModel': '模型',
  'muse.task.colTitle': '标题',
  'muse.task.colStatus': '状态',
  'muse.task.colCredit': '消耗点数',
  'muse.task.colCreatedAt': '时间',
  'muse.task.colAction': '操作',
  'muse.task.searchPlaceholder': '搜索标题 / 模型',
  'muse.task.empty': '暂无任务',
  'muse.task.typeAll': '全部类型',
  'muse.task.statusAll': '全部状态',
  'muse.task.deleteSuccess': '删除成功',
  'muse.task.deleteFailed': '删除失败',
  'muse.task.detail': '详情',
  'muse.task.detailTitle': '任务详情',
  'muse.task.copy': '复制',
  'muse.task.copied': '已复制',
  'muse.task.fieldUser': '用户',
  'muse.task.fieldType': '类型',
  'muse.task.fieldModel': '模型',
  'muse.task.fieldTitle': '标题',
  'muse.task.fieldStatus': '状态',
  'muse.task.fieldCredit': '消耗点数',
  'muse.task.fieldCreatedAt': '创建时间',
  'muse.task.fieldRemoteTaskId': '云端任务 ID',
  'muse.task.fieldChainTaskId': '前置任务 ID',
  'muse.task.fieldStatusRemark': '失败原因',
  'muse.task.request': '请求参数',
  'muse.task.requestEmpty': '无请求参数',
  'muse.task.result': '合成结果',
  'muse.task.resultEmpty': '暂无结果',
  'muse.task.resultUrl': '结果地址',
  'muse.task.none': '无',
  'muse.task.userInfoTitle': '用户信息',
  'muse.task.userBasic': '基础信息',
  'muse.task.userId': '用户 ID',
  'muse.task.username': '用户名',
  'muse.task.userEmail': '邮箱',
  'muse.task.userNoEmail': '未绑定邮箱',
  'muse.task.userRole': '角色',
  'muse.task.userStatus': '状态',
  'muse.task.userCredit': '点数',
  'muse.task.userCreatedAt': '注册时间',
  'muse.task.editUser': '修改',
  'muse.task.adjustCredit': '调整点数',
  'muse.task.roleAdmin': '管理员',
  'muse.task.roleUser': '普通用户',
  'muse.task.statusNormal': '正常',
  'muse.task.statusDisabled': '已禁用',
  'muse.task.userLoadFailed': '用户信息加载失败',

  // 模型配置
  'muse.model.title': '接口配置',
  'muse.model.credTitle': '服务凭证',
  'muse.model.guideBefore': '前往 ',
  'muse.model.guideAfter': ' 注册并创建应用，在应用详情中获取 AppId 与 AppSecret；服务地址默认使用 https://api.tecmz.com/open_api，一般无需修改。',
  'muse.model.baseUrl': '服务地址',
  'muse.model.appId': 'AppId',
  'muse.model.appSecret': 'AppSecret',
  'muse.model.ping': '测试连接',
  'muse.model.pingOk': '连接成功',
  'muse.model.pingFailed': '连接失败',
  'muse.model.saved': '已保存',
  'muse.model.saveFailed': '保存失败',

  // 数字人形象（管理）
  'muse.avatarPreset.title': '平台数字人形象',
  'muse.avatarPreset.enabled': '已启用',
  'muse.avatarPreset.disabled': '已停用',
  'muse.avatarPreset.add': '新增形象',
  'muse.avatarPreset.edit': '修改形象',
  'muse.avatarPreset.empty': '暂无形象',
  'muse.avatarPreset.name': '名称',
  'muse.avatarPreset.namePlaceholder': '如：默认女主播形象',
  'muse.avatarPreset.video': '形象视频',
  'muse.avatarPreset.needVideo': '请先上传形象视频',
  'muse.avatarPreset.uploadHint': '上传视频将自动截取第 1 秒作为封面',
  'muse.avatarPreset.uploadSuccess': '上传成功',
  'muse.avatarPreset.uploadFailed': '上传失败',
  'muse.avatarPreset.model': '云端模型名',
  'muse.avatarPreset.enable': '启用',
  'muse.avatarPreset.saveSuccess': '保存成功',
  'muse.avatarPreset.saveFailed': '保存失败',
  'muse.avatarPreset.deleteSuccess': '删除成功',
  'muse.avatarPreset.deleteFailed': '删除失败',

  // 音色模板（用户）
  'muse.voiceTemplate.title': '音色模板',
  'muse.voiceTemplate.desc': '创建声音合成 / 声音克隆模板，合成时直接选用',
  'muse.voiceTemplate.create': '新增',
  'muse.voiceTemplate.createGuide': '新建音色模板',
  'muse.voiceTemplate.edit': '修改',
  'muse.voiceTemplate.empty': '暂无模板',
  'muse.voiceTemplate.type': '模板类型',
  'muse.voiceTemplate.typeTtsDesc': '选择云端音色直接合成',
  'muse.voiceTemplate.typeCloneDesc': '上传参考音频复刻音色',
  'muse.voiceTemplate.name': '模板名称',
  'muse.voiceTemplate.namePlaceholder': '如：我的音色',
  'muse.voiceTemplate.modelKey': '模型',
  'muse.voiceTemplate.param': '参数配置',
  'muse.voiceTemplate.speaker': '音色',
  'muse.voiceTemplate.pickSpeaker': '选择音色',
  'muse.voiceTemplate.refAudio': '参考音频',
  'muse.voiceTemplate.refAudioHint': '上传一段清晰的人声作为参考音频',
  'muse.voiceTemplate.refText': '参考文本',
  'muse.voiceTemplate.refTextPlaceholder': '音频对应的文本内容（可选，越精准效果越好）',
  'muse.voiceTemplate.speed': '语速',
  'muse.voiceTemplate.copyId': '点击复制 ID',
  'muse.voiceTemplate.copied': '已复制',
  'muse.voiceTemplate.uploadSuccess': '上传成功',
  'muse.voiceTemplate.createSuccess': '创建成功',
  'muse.voiceTemplate.createFailed': '创建失败',
  'muse.voiceTemplate.updateSuccess': '修改成功',
  'muse.voiceTemplate.updateFailed': '修改失败',
  'muse.voiceTemplate.deleteSuccess': '删除成功',
  'muse.voiceTemplate.deleteFailed': '删除失败',
  'muse.voiceTemplate.needAudio': '请先上传参考音频',
  'muse.voiceTemplate.needSpeaker': '请先选择音色',
  'muse.voiceTemplate.needModel': '请先选择复刻模型',

  // 音色目录（云端）
  'muse.speaker.search': '搜索音色名称',
  'muse.speaker.allLangs': '全部语种',
  'muse.speaker.allModels': '全部模型',
  'muse.speaker.empty': '暂无音色',
  'muse.speaker.loadFailed': '音色加载失败',
  'muse.speaker.select': '选择',
  'muse.speaker.selected': '已选',
  'muse.speaker.preview': '试听',
  'muse.speaker.previewing': '试听中',
  'muse.speaker.current': '当前音色',
  'muse.speaker.pickHint': '点击卡片直接选择音色',
  'muse.speaker.previewHint': '点击 ▶ 可试听',
  'muse.speaker.clearFilters': '清空筛选',
  'muse.speaker.total': '共 {total} 个音色',

  // 声音合成（用户）
  'muse.voice.title': '声音合成',
  'muse.voice.template': '音色模板',
  'muse.voice.pickerTitle': '选择音色',
  'muse.voice.pickSpeaker': '选择音色',
  'muse.voice.emptyTemplate': '暂无音色模板，请先在「音色模板」创建',
  'muse.voice.goTemplate': '去创建',
  'muse.voice.text': '合成文本',
  'muse.voice.textPlaceholder': '请输入要合成的文本',
  'muse.voice.adjustParam': '调整参数',
  'muse.voice.paramHint': '默认使用模板参数，可在此覆盖本次合成',
  'muse.voice.submit': '开始合成',
  'muse.voice.submitSuccess': '任务已提交',
  'muse.voice.submitFailed': '提交失败',
  'muse.voice.needText': '请输入合成文本',
  'muse.voice.needTemplate': '请先选择音色模板',
  'muse.voice.balance': '点数',
  'muse.voice.history': '合成记录',
  'muse.voice.empty': '暂无合成记录',
  'muse.voice.emptyFiltered': '没有符合筛选条件的记录',
  'muse.voice.previewPending': '合成完成后可在此试听',
  'muse.voice.creditCost': '{n} 点',
  'muse.voice.copyId': '点击复制 ID',
  'muse.voice.copied': '已复制',
  'muse.voice.untitled': '未命名',
  'muse.voice.download': '下载',
  'muse.voice.deleteSuccess': '删除成功',
  'muse.voice.deleteFailed': '删除失败',
  'muse.voice.synthRunning': '合成中，完成后可试听',
  'muse.voice.failNoReason': '合成失败，请重试',
  'muse.voice.retry': '重试',
  'muse.voice.resynthesize': '重新合成',
  'muse.voice.copyText': '复制文本',
  'muse.voice.copyLink': '复制链接',
  'muse.voice.textCopied': '文本已复制',
  'muse.voice.linkCopied': '链接已复制',
  'muse.voice.refilled': '已填入合成文本，可直接重新合成',
  'muse.voice.noTextToReuse': '该记录没有可复用的文本',
  'muse.voice.loadMore': '加载更多',
  'muse.voice.allLoaded': '已全部加载',
  'muse.voice.filterTypeAll': '全部类型',
  'muse.voice.filterStatusAll': '全部状态',

  // 数字人形象（用户）
  'muse.avatar.title': '数字人形象',
  'muse.avatar.desc': '管理平台预设形象与我的上传形象',
  'muse.avatar.myAvatars': '我的形象',
  'muse.avatar.presets': '平台形象',
  'muse.avatar.create': '新增形象',
  'muse.avatar.empty': '暂无形象',
  'muse.avatar.name': '形象名称',
  'muse.avatar.namePlaceholder': '如：我的形象',
  'muse.avatar.video': '形象视频',
  'muse.avatar.uploadHint': '点击上传拍摄好的原始视频',
  'muse.avatar.uploadSuccess': '上传成功',
  'muse.avatar.standardTitle': '标准示例',
  'muse.avatar.standRef': '站姿参考',
  'muse.avatar.sitRef': '坐姿参考',
  'muse.avatar.rule1': '视频时长最少 8 秒，说话吐字清晰；',
  'muse.avatar.rule2': '视频前后有且只有同一个人；',
  'muse.avatar.rule3': '五官清晰不遮挡，头部不倾斜或侧向，手势不要出现在面部、嘴巴、脖子；',
  'muse.avatar.rule4': '视频分辨率最低 720P；',
  'muse.avatar.rule5': '视频格式为 MP4 / MOV。',
  'muse.avatar.errorTitle': '错误示例',
  'muse.avatar.errMultiFace': '多张人脸',
  'muse.avatar.errBigFace': '面部过大',
  'muse.avatar.errNoFace': '未检测到人脸',
  'muse.avatar.errOccluded': '五官遮挡',
  'muse.avatar.createSuccess': '创建成功',
  'muse.avatar.createFailed': '创建失败',
  'muse.avatar.edit': '修改形象',
  'muse.avatar.updateSuccess': '修改成功',
  'muse.avatar.updateFailed': '修改失败',
  'muse.avatar.deleteSuccess': '删除成功',
  'muse.avatar.deleteFailed': '删除失败',
  'muse.avatar.needVideo': '请先上传形象视频',
  'muse.avatar.download': '下载',
  'muse.avatar.copyId': '点击复制 ID',
  'muse.avatar.copied': '已复制',
  'muse.avatar.noVideo': '暂无视频',
  'muse.avatar.videoUnavailable': '视频暂不可用',

  // 数字人生成（用户）
  'muse.avatarGenerate.title': '数字人生成',
  'muse.avatarGenerate.avatar': '数字人形象',
  'muse.avatarGenerate.model': '生成模型',
  'muse.avatarGenerate.modelPlaceholder': '请选择生成模型',
  'muse.avatarGenerate.audio': '驱动音频',
  'muse.avatarGenerate.driverText': '输入文字',
  'muse.avatarGenerate.driverTextDesc': '选择音色模板并输入文本驱动',
  'muse.avatarGenerate.driverUpload': '上传音频',
  'muse.avatarGenerate.driverUploadDesc': '上传本地音频文件驱动',
  'muse.avatarGenerate.driverSelect': '选择音频',
  'muse.avatarGenerate.driverSelectDesc': '从合成记录中挑选音频',
  'muse.avatarGenerate.voicePlaceholder': '请选择音色模板',
  'muse.avatarGenerate.textPlaceholder': '请输入要合成的驱动文本',
  'muse.avatarGenerate.noVoice': '暂无音色模板，请先前往「音色模板」创建',
  'muse.avatarGenerate.uploadHint': '选择一个本地音频文件作为驱动音频',
  'muse.avatarGenerate.uploadSuccess': '上传成功',
  'muse.avatarGenerate.reupload': '点击更换音频',
  'muse.avatarGenerate.selectHint': '从「声音合成」页的历史音频中选择一个作为驱动音频',
  'muse.avatarGenerate.reselect': '点击更换音频',
  'muse.avatarGenerate.pickerTitle': '选择音频',
  'muse.avatarGenerate.pickerEmpty': '暂无合成音频',
  'muse.avatarGenerate.pickerSelect': '选择',
  'muse.avatarGenerate.titleField': '标题',
  'muse.avatarGenerate.titlePlaceholder': '选填，便于区分作品',
  'muse.avatarGenerate.submit': '开始生成',
  'muse.avatarGenerate.submitSuccess': '任务已提交',
  'muse.avatarGenerate.submitFailed': '提交失败',
  'muse.avatarGenerate.needAudio': '请提供驱动音频',
  'muse.avatarGenerate.needAvatar': '请选择数字人形象',
  'muse.avatarGenerate.needModel': '请选择生成模型',
  'muse.avatarGenerate.needText': '请输入驱动文本',
  'muse.avatarGenerate.needVoice': '请选择音色模板',
  'muse.avatarGenerate.history': '生成记录',
  'muse.avatarGenerate.empty': '暂无生成记录',
  'muse.avatarGenerate.download': '下载视频',
  'muse.avatarGenerate.untitled': '未命名作品',
  'muse.avatarGenerate.copyId': '点击复制 ID',
  'muse.avatarGenerate.copied': '已复制',
  'muse.avatarGenerate.noAvatar': '暂无可用形象',
  'muse.avatarGenerate.noAvatarHint': '请先前往「数字人形象」新增',
  'muse.avatarGenerate.goAvatar': '去新增',

  // 首页（用户工作台）
  'muse.home.title': '工作台',
  'muse.home.overview.title': '数据概览',
  'muse.home.overview.updateAt': '更新于 {time}',
  'muse.home.overview.voice': '声音合成',
  'muse.home.overview.clone': '声音复刻',
  'muse.home.overview.avatar': '数字人形象',
  'muse.home.overview.video': '数字人视频',
  'muse.home.overview.today': '今日 {value}',
  'muse.home.quick.voiceTitle': '声音合成',
  'muse.home.quick.voiceDesc': '输入文本，选择音色模板，一键合成自然语音',
  'muse.home.quick.voiceAction': '立即合成',
  'muse.home.quick.cloneTitle': '声音复刻',
  'muse.home.quick.cloneDesc': '上传参考音频，复刻专属音色，20 秒快速完成',
  'muse.home.quick.cloneAction': '立即复刻',
  'muse.home.quick.avatarTitle': '数字人视频',
  'muse.home.quick.avatarDesc': '选择数字人形象，用音频或文字驱动生成视频',
  'muse.home.quick.avatarAction': '立即生成',
  'muse.home.wallet.title': '我的钱包',
  'muse.home.wallet.balance': '点数余额',
  'muse.home.wallet.todayUsed': '今日用量',
  'muse.home.wallet.recharge': '充值',
  'muse.home.trend.voiceTitle': '声音合成',
  'muse.home.trend.videoTitle': '数字人视频',
  'muse.home.trend.voiceSeries': '合成次数',
  'muse.home.trend.videoSeries': '生成次数',
  'muse.home.trend.range': '近 14 天',
  'muse.home.trend.empty': '近 14 天暂无数据',
  'muse.home.loadFailed': '数据加载失败',
  // 仪表盘补充 / 任务重试 / 表单细节
  'muse.dashboard.statToday': '今日',
  'muse.dashboard.statConsumedUnit': '仅统计成功任务',
  'muse.dashboard.statUsersHint': '注册用户总数',
  'muse.dashboard.trendTitle': '任务趋势',
  'muse.dashboard.trendRange': '近 14 天',
  'muse.dashboard.trendEmpty': '近 14 天暂无任务',
  'muse.dashboard.trendSeries': '任务数',
  'muse.dashboard.typeTitle': '类型分布',
  'muse.dashboard.successRate': '成功率',
  'muse.dashboard.successRateHint': '成功 {success} · 失败 {fail}',
  'muse.dashboard.recentTitle': '最近任务',
  'muse.dashboard.recentEmpty': '暂无任务',
  'muse.dashboard.viewAll': '查看全部',
  'muse.dashboard.quickTitle': '快捷入口',
  'muse.dashboard.quickTask': '合成任务',
  'muse.dashboard.quickPreset': '平台数字人形象',
  'muse.dashboard.quickModel': '接口配置',
  'muse.dashboard.channelTitle': '渠道效果',
  'muse.dashboard.channelSummary': '注册 {registers} · 激活 {activated}',
  'muse.dashboard.channelColChannel': '渠道',
  'muse.dashboard.channelColRegisters': '注册',
  'muse.dashboard.channelColActivated': '激活',
  'muse.dashboard.channelColRate': '激活率',
  'muse.dashboard.channelColTasks': '任务数',
  'muse.dashboard.channelColConsumed': '消耗',
  'muse.dashboard.channelEmpty': '暂无渠道数据',
  'muse.voice.fillExample': '填入示例',
  'muse.voice.exampleText': '欢迎使用数字人配音，这是一段用于试听的示例文案。',
  'muse.avatarGenerate.retry': '重试',
  'muse.avatarGenerate.retrySubmitted': '已重新提交，可在记录中查看进度',
  'muse.avatarGenerate.retryFailed': '重试失败',
  'muse.model.unchanged': '当前没有未保存的修改',
  'muse.model.lastPing': '最近测试：{result} · {time}',
  'muse.model.lastPingEmpty': '尚未测试连接',
  'muse.home.overview.cumulative': '累计',
  'muse.task.resetFilter': '重置筛选',
  'muse.home.trend.unit': '次',
  'muse.voiceTemplate.submitHint': '请填写模板名称，并选择音色或上传参考音频',
  'muse.pricing.title': '计费设置',
  'muse.pricing.typeTitle': '按类型定价',
  'muse.pricing.typeDesc': '留空即沿用云端目录价；单位量表示「多少字符 / 分钟算一个计价单位」。',
  'muse.pricing.cloudPrice': '云端当前价',
  'muse.pricing.price': '单价（点）',
  'muse.pricing.unitSize': '单位量',
  'muse.pricing.inherit': '沿用云端',
  'muse.pricing.unitText': '每 {n} 字符',
  'muse.pricing.unitMinute': '每分钟',
  'muse.pricing.unitCount': '每次',
  'muse.pricing.modelTitle': '按模型覆盖',
  'muse.pricing.modelDesc': '同一类型下不同模型可单独定价，填写后优先级高于上面的类型价格。',
  'muse.pricing.catalogEmpty': '云端模型目录暂不可用，请先在「接口配置」中检查模型服务凭证。',
  'muse.pricing.colModel': '模型',
  'muse.pricing.colType': '类型',
  'muse.pricing.noticeTitle': '计费提示',
  'muse.pricing.noticeDesc': '展示在「声音合成」与「数字人生成」的提交区，两个页面共用同一份内容。',
  'muse.pricing.noticeReset': '恢复默认',
  'muse.pricing.saved': '已保存',
  'muse.pricing.saveFailed': '保存失败',
  'muse.pricing.unchanged': '当前没有未保存的修改',
}
